import type { BridgeTheme } from "./types";

export const COALITION_THEME: BridgeTheme = {
  id: "coalition",
  name: "Stellar Coalition Standard",

  colors: {
    bgDeep: "#0a0c14",
    bgPanel: "#0f1220",
    bgSurface: "#151929",
    borderColor: "#1e2540",
    borderHighlight: "#2a3558",
    text: "#c8cee0",
    textDim: "#6b7394",
    textBright: "#e8ecf5",
    blue: "#4a8eff",
    teal: "#2dd4bf",
    green: "#34d399",
    yellow: "#fbbf24",
    orange: "#f97316",
    red: "#ef4444",
    purple: "#a78bfa",
    amber: "#f59e0b",
  },

  fonts: {
    mono: '"JetBrains Mono", "Fira Code", "SF Mono", "Cascadia Code", monospace',
    body: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  },

  panel: {
    bg: "rgba(6, 10, 22, 0.82)",
    blur: "18px",
    border: "rgba(30, 40, 70, 0.9)",
    titlebarBg: "rgba(10, 18, 40, 0.9)",
    titlebarBorder: "rgba(40, 60, 110, 0.7)",
    titlebarHoverBg: "rgba(20, 35, 70, 0.95)",
    dragIcon: "rgba(80, 120, 200, 0.4)",
    dragIconHover: "rgba(120, 180, 255, 0.85)",
    titleColor: "rgba(120, 175, 255, 0.8)",
    radius: "6px",
  },

  viewscreen: {
    frameBorder: "rgba(40, 80, 160, 0.5)",
    frameGlow: "rgba(40, 100, 200, 0.15)",
    frameGlowSize: "12px",
    cornerAccent: "rgba(80, 160, 255, 0.5)",
    radius: "6px",
    scanlineOpacity: 0,
    vignetteOpacity: 0.3,
  },

  alerts: {
    normal: "var(--color-teal)",
    yellow: "var(--color-yellow)",
    red: "var(--color-red)",
  },
};
